const SearchSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7099 20.29L17.9999 16.61C19.44 14.8144 20.1374 12.5353 19.9487 10.2413C19.76 7.94731 18.6996 5.81279 16.9854 4.27665C15.2713 2.74051 13.0337 1.91951 10.7328 1.98247C8.43194 2.04543 6.24263 2.98757 4.61505 4.61515C2.98747 6.24273 2.04534 8.43204 1.98237 10.7329C1.91941 13.0338 2.74041 15.2714 4.27655 16.9855C5.81269 18.6997 7.94721 19.7601 10.2412 19.9488C12.5352 20.1375 14.8143 19.4401 16.6099 18L20.2899 21.68C20.3829 21.7737 20.4935 21.8481 20.6153 21.8989C20.7372 21.9497 20.8679 21.9758 20.9999 21.9758C21.1319 21.9758 21.2626 21.9497 21.3845 21.8989C21.5063 21.8481 21.6169 21.7737 21.7099 21.68C21.8901 21.4935 21.9909 21.2443 21.9909 20.985C21.9909 20.7257 21.8901 20.4765 21.7099 20.29ZM10.9999 18C9.61544 18 8.26206 17.5895 7.11091 16.8203C5.95977 16.0511 5.06256 14.9579 4.53275 13.6788C4.00293 12.3997 3.86431 10.9922 4.13441 9.63437C4.4045 8.2765 5.07119 7.02922 6.05016 6.05026C7.02912 5.07129 8.27641 4.4046 9.63427 4.13451C10.9921 3.86441 12.3996 4.00303 13.6787 4.53285C14.9578 5.06266 16.051 5.95987 16.8202 7.11101C17.5894 8.26216 17.9999 9.61553 17.9999 11C17.9999 12.8565 17.2624 14.637 15.9497 15.9498C14.6369 17.2625 12.8564 18 10.9999 18Z"
        fill="#EAEAEA"
      />
    </svg>
  )
}

const LikeSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_37_34"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={2}
        y={3}
        width={21}
        height={20}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2.9999H22.4725V22.5009H2V2.9999Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_37_34)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.82371 12.123C5.22571 16.485 10.7647 20.012 12.2367 20.885C13.7137 20.003 19.2927 16.437 20.6497 12.127C21.5407 9.341 20.7137 5.812 17.4277 4.753C15.8357 4.242 13.9787 4.553 12.6967 5.545C12.4287 5.751 12.0567 5.755 11.7867 5.551C10.4287 4.53 8.65471 4.231 7.03771 4.753C3.75671 5.811 2.93271 9.34 3.82371 12.123ZM12.2377 22.501C12.1137 22.501 11.9907 22.471 11.8787 22.41C11.5657 22.239 4.19271 18.175 2.39571 12.581C2.39471 12.581 2.39471 12.58 2.39471 12.58C1.26671 9.058 2.52271 4.632 6.57771 3.325C8.48171 2.709 10.5567 2.98 12.2347 4.039C13.8607 3.011 16.0207 2.727 17.8867 3.325C21.9457 4.634 23.2057 9.059 22.0787 12.58C20.3397 18.11 12.9127 22.235 12.5977 22.408C12.4857 22.47 12.3617 22.501 12.2377 22.501Z"
          fill="#EAEAEA"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1537 10.6249C17.7667 10.6249 17.4387 10.3279 17.4067 9.9359C17.3407 9.1139 16.7907 8.4199 16.0077 8.1669C15.6127 8.0389 15.3967 7.6159 15.5237 7.2229C15.6527 6.8289 16.0717 6.6149 16.4677 6.7389C17.8307 7.1799 18.7857 8.3869 18.9027 9.8139C18.9357 10.2269 18.6287 10.5889 18.2157 10.6219C18.1947 10.6239 18.1747 10.6249 18.1537 10.6249Z"
        fill="#EAEAEA"
      />
    </svg>
  )
}

const UserSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.889 12.6187H11.921C14.849 12.6187 17.23 10.2377 17.23 7.30971C17.23 4.38171 14.849 1.99971 11.921 1.99971C8.99202 1.99971 6.61002 4.38171 6.61002 7.30671C6.60002 10.2267 8.96702 12.6097 11.889 12.6187ZM8.03802 7.30971C8.03802 5.16871 9.78002 3.42771 11.921 3.42771C14.061 3.42771 15.802 5.16871 15.802 7.30971C15.802 9.44971 14.061 11.1917 11.921 11.1917H11.892C9.76002 11.1837 8.03102 9.44371 8.03802 7.30971Z"
        fill="#EAEAEA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 18.173C4 21.87 9.962 21.87 11.921 21.87C15.32 21.87 19.84 21.489 19.84 18.193C19.84 14.496 13.88 14.496 11.921 14.496C8.521 14.496 4 14.877 4 18.173ZM5.5 18.173C5.5 16.728 7.66 15.996 11.921 15.996C16.181 15.996 18.34 16.735 18.34 18.193C18.34 19.638 16.181 20.37 11.921 20.37C7.66 20.37 5.5 19.631 5.5 18.173Z"
        fill="#EAEAEA"
      />
    </svg>
  )
}

const CartSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5136 21.5H8.16579C5.09943 21.5 2.74703 20.3924 3.41522 15.9348L4.19325 9.89359C4.60515 7.66934 6.02392 6.81808 7.26877 6.81808H17.4473C18.7104 6.81808 20.0468 7.73341 20.5228 9.89359L21.3008 15.9348C21.8683 19.889 19.58 21.5 16.5136 21.5Z"
        stroke="#EAEAEA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.651 6.5984C16.651 4.21232 14.7167 2.27803 12.3306 2.27803V2.27803C11.1816 2.27316 10.078 2.72619 9.26381 3.53695C8.44963 4.3477 7.99193 5.44939 7.99194 6.5984H7.99194"
        stroke="#EAEAEA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2962 11.1018H15.2505"
        stroke="#EAEAEA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.46566 11.1018H9.41989"
        stroke="#EAEAEA"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const HomeSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.63093 17.3095V14.7539C7.63092 14.1039 8.16085 13.5757 8.81743 13.5713H11.2225C11.8822 13.5713 12.417 14.1008 12.417 14.7539V14.7539V17.3174C12.4169 17.8693 12.8618 18.3204 13.4191 18.3333H15.0225C16.6209 18.3333 17.9166 17.0506 17.9166 15.4682V15.4682V8.19819C17.908 7.57568 17.6128 6.99111 17.1149 6.61085L11.6314 2.23774C10.6707 1.4763 9.30509 1.4763 8.34443 2.23774L2.88494 6.61879C2.38513 6.99751 2.08941 7.58305 2.08325 8.20612V15.4682C2.08325 17.0506 3.37898 18.3333 4.97734 18.3333H6.58072C7.15188 18.3333 7.6149 17.8749 7.6149 17.3095V17.3095"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const JobSvg = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9957 15.287V12.9615"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6741 4.88602C18.2233 4.88602 19.4699 6.14185 19.4699 7.69102V10.8443C17.2149 12.1643 14.2358 12.9619 10.9908 12.9619C7.74575 12.9619 4.77575 12.1643 2.52075 10.8443V7.68185C2.52075 6.13268 3.77659 4.88602 5.32575 4.88602H16.6741Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.204 4.88196V4.54646C14.204 3.42813 13.2965 2.52063 12.1782 2.52063H9.81319C8.69485 2.52063 7.78735 3.42813 7.78735 4.54646V4.88196"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.54321 14.1927L2.71646 16.4927C2.8338 18.0427 4.12538 19.2408 5.67913 19.2408H16.3115C17.8653 19.2408 19.1569 18.0427 19.2742 16.4927L19.4475 14.1927"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const FootballSvg = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 5.95833C2.75 3.55189 2.77577 2.75 5.95833 2.75C9.1409 2.75 9.16667 3.55189 9.16667 5.95833C9.16667 8.36478 9.17682 9.16667 5.95833 9.16667C2.73985 9.16667 2.75 8.36478 2.75 5.95833Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8333 5.95833C12.8333 3.55189 12.859 2.75 16.0416 2.75C19.2242 2.75 19.2499 3.55189 19.2499 5.95833C19.2499 8.36478 19.2601 9.16667 16.0416 9.16667C12.8231 9.16667 12.8333 8.36478 12.8333 5.95833Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 16.0417C2.75 13.6352 2.77577 12.8333 5.95833 12.8333C9.1409 12.8333 9.16667 13.6352 9.16667 16.0417C9.16667 18.4481 9.17682 19.25 5.95833 19.25C2.73985 19.25 2.75 18.4481 2.75 16.0417Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8333 16.0417C12.8333 13.6352 12.859 12.8333 16.0416 12.8333C19.2242 12.8333 19.2499 13.6352 19.2499 16.0417C19.2499 18.4481 19.2601 19.25 16.0416 19.25C12.8231 19.25 12.8333 18.4481 12.8333 16.0417Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  )
}
const CheckedSvg = () => {
  return (
    <svg
      width={25}
      height={25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={25} height={25} rx="12.5" fill="#6E1DC6" />
      <path
        d="M18.7099 8.20998C18.617 8.11625 18.5064 8.04186 18.3845 7.99109C18.2627 7.94032 18.132 7.91418 17.9999 7.91418C17.8679 7.91418 17.7372 7.94032 17.6154 7.99109C17.4935 8.04186 17.3829 8.11625 17.29 8.20998L9.83995 15.67L6.70995 12.53C6.61343 12.4367 6.49949 12.3634 6.37463 12.3142C6.24978 12.265 6.11645 12.2409 5.98227 12.2432C5.84809 12.2455 5.71568 12.2743 5.5926 12.3278C5.46953 12.3812 5.35819 12.4585 5.26495 12.555C5.17171 12.6515 5.0984 12.7654 5.04919 12.8903C4.99999 13.0152 4.97586 13.1485 4.97818 13.2827C4.9805 13.4168 5.00923 13.5493 5.06272 13.6723C5.11622 13.7954 5.19343 13.9067 5.28995 14L9.12995 17.84C9.22291 17.9337 9.33351 18.0081 9.45537 18.0589C9.57723 18.1096 9.70794 18.1358 9.83995 18.1358C9.97196 18.1358 10.1027 18.1096 10.2245 18.0589C10.3464 18.0081 10.457 17.9337 10.55 17.84L18.7099 9.67998C18.8115 9.58634 18.8925 9.47269 18.9479 9.34619C19.0033 9.21969 19.0319 9.08308 19.0319 8.94498C19.0319 8.80688 19.0033 8.67028 18.9479 8.54378C18.8925 8.41728 18.8115 8.30363 18.7099 8.20998Z"
        fill="white"
      />
    </svg>


  )
}
export const PencilSvg = () => {
  return (
    <svg width={25} height={25} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 0L16 3L9 10H6V7L13 0Z" fill="#6E1DC6" />
      <path d="M1 1V15H15V9H13V13H3V3H7V1H1Z" fill="#6E1DC6" />
    </svg>


  )
}
const LikePurpleSvg = ({ isLiked }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1598 4.61C19.0981 3.548 17.6905 2.90232 16.193 2.79038C14.6955 2.67843 13.2076 3.10766 11.9998 4C10.7274 3.05363 9.14378 2.62451 7.56771 2.79903C5.99164 2.97356 4.54023 3.73877 3.50576 4.94058C2.47129 6.14239 1.93061 7.69152 1.99259 9.27601C2.05457 10.8605 2.71461 12.3627 3.83979 13.48L11.2898 20.93C11.3828 21.0237 11.4934 21.0981 11.6152 21.1489C11.7371 21.1997 11.8678 21.2258 11.9998 21.2258C12.1318 21.2258 12.2625 21.1997 12.3844 21.1489C12.5062 21.0981 12.6168 21.0237 12.7098 20.93L20.1598 13.48C20.7424 12.8977 21.2047 12.2063 21.52 11.4454C21.8354 10.6844 21.9977 9.86873 21.9977 9.045C21.9977 8.22127 21.8354 7.40561 21.52 6.64463C21.2047 5.88365 20.7424 5.19227 20.1598 4.61Z"
        fill={isLiked ? "#CD10A2" : "none"}
        stroke={!isLiked ? "#000" : "#CD10A2"}
        strokeWidth="1.5"
      />
    </svg>

  )
}
const EmptyStar = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="#e0e0e0"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
      }}
    >
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
    </svg>
  )
}
const HalfStar = ({ star }) => {
  return (
    <div style={{ position: 'relative', width: '20px', height: '20px' }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="#e0e0e0"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'absolute', top: 0, left: 0 }}
      >
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="#FFD700"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          clipPath: `inset(0 ${100 - star.percentage}% 0 0)`
        }}
      >
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
    </div>
  )
}
const FullStar = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="#FFD700"
      xmlns="http://www.w3.org/2000/svg"
      style={{ position: 'absolute', top: 0, left: 0 }}
    >
      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
    </svg>
  )
}
const UploadSvg = () => {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.00527 9.73267H6.99452C4.78994 9.73267 3.00244 11.5202 3.00244 13.7248V19.006C3.00244 21.2095 4.78994 22.997 6.99452 22.997H19.052C21.2566 22.997 23.0441 21.2095 23.0441 19.006V13.7139C23.0441 11.5158 21.262 9.73267 19.0639 9.73267H18.0424" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M13.0231 2.37306V15.4175" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9.86523 5.54541L13.0232 2.37341L16.1822 5.54541" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
const CartwhiteSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7729 9.30504V6.27304C15.7729 4.18904 14.0839 2.50004 12.0009 2.50004C9.91694 2.49104 8.21994 4.17204 8.21094 6.25604V6.27304V9.30504"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7422 21.0004H7.25778C4.90569 21.0004 3 19.0954 3 16.7454V11.2294C3 8.87937 4.90569 6.97437 7.25778 6.97437H16.7422C19.0943 6.97437 21 8.87937 21 11.2294V16.7454C21 19.0954 19.0943 21.0004 16.7422 21.0004Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>


  )
}
const CrossSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4099 12L17.7099 7.71C17.8982 7.52169 18.004 7.2663 18.004 7C18.004 6.7337 17.8982 6.4783 17.7099 6.29C17.5216 6.10169 17.2662 5.99591 16.9999 5.99591C16.7336 5.99591 16.4782 6.10169 16.2899 6.29L11.9999 10.59L7.70994 6.29C7.52164 6.10169 7.26624 5.99591 6.99994 5.99591C6.73364 5.99591 6.47824 6.10169 6.28994 6.29C6.10164 6.4783 5.99585 6.7337 5.99585 7C5.99585 7.2663 6.10164 7.52169 6.28994 7.71L10.5899 12L6.28994 16.29C6.19621 16.383 6.12182 16.4936 6.07105 16.6154C6.02028 16.7373 5.99414 16.868 5.99414 17C5.99414 17.132 6.02028 17.2627 6.07105 17.3846C6.12182 17.5064 6.19621 17.617 6.28994 17.71C6.3829 17.8037 6.4935 17.8781 6.61536 17.9289C6.73722 17.9797 6.86793 18.0058 6.99994 18.0058C7.13195 18.0058 7.26266 17.9797 7.38452 17.9289C7.50638 17.8781 7.61698 17.8037 7.70994 17.71L11.9999 13.41L16.2899 17.71C16.3829 17.8037 16.4935 17.8781 16.6154 17.9289C16.7372 17.9797 16.8679 18.0058 16.9999 18.0058C17.132 18.0058 17.2627 17.9797 17.3845 17.9289C17.5064 17.8781 17.617 17.8037 17.7099 17.71C17.8037 17.617 17.8781 17.5064 17.9288 17.3846C17.9796 17.2627 18.0057 17.132 18.0057 17C18.0057 16.868 17.9796 16.7373 17.9288 16.6154C17.8781 16.4936 17.8037 16.383 17.7099 16.29L13.4099 12Z"
        fill="white"
      />
    </svg>

  )
}
const RadioSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width={19} height={19} rx="9.5" stroke="white" />
      <rect x={4} y={4} width={12} height={12} rx={6} fill="#D9D9D9" />
    </svg>
  )
}
const PasswordSvg = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0543 8.66047V6.69239C15.0543 4.38881 13.1861 2.52064 10.8825 2.52064C8.57894 2.51056 6.70344 4.36956 6.69336 6.67406V6.69239V8.66047"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3758 19.4788H7.37151C5.45201 19.4788 3.89551 17.9232 3.89551 16.0028V12.0712C3.89551 10.1508 5.45201 8.59521 7.37151 8.59521H14.3758C16.2953 8.59521 17.8518 10.1508 17.8518 12.0712V16.0028C17.8518 17.9232 16.2953 19.4788 14.3758 19.4788Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8743 13.0191V15.0551"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>


  )
}
const CanselSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7098 8.28999C15.6169 8.19626 15.5063 8.12187 15.3844 8.0711C15.2626 8.02033 15.1318 7.99419 14.9998 7.99419C14.8678 7.99419 14.7371 8.02033 14.6153 8.0711C14.4934 8.12187 14.3828 8.19626 14.2898 8.28999L11.9998 10.59L9.70984 8.28999C9.52153 8.10168 9.26614 7.9959 8.99984 7.9959C8.73353 7.9959 8.47814 8.10168 8.28983 8.28999C8.10153 8.47829 7.99574 8.73369 7.99574 8.99999C7.99574 9.26629 8.10153 9.52168 8.28983 9.70999L10.5898 12L8.28983 14.29C8.19611 14.383 8.12171 14.4936 8.07094 14.6154C8.02017 14.7373 7.99404 14.868 7.99404 15C7.99404 15.132 8.02017 15.2627 8.07094 15.3846C8.12171 15.5064 8.19611 15.617 8.28983 15.71C8.3828 15.8037 8.4934 15.8781 8.61526 15.9289C8.73712 15.9796 8.86782 16.0058 8.99984 16.0058C9.13185 16.0058 9.26255 15.9796 9.38441 15.9289C9.50627 15.8781 9.61687 15.8037 9.70984 15.71L11.9998 13.41L14.2898 15.71C14.3828 15.8037 14.4934 15.8781 14.6153 15.9289C14.7371 15.9796 14.8678 16.0058 14.9998 16.0058C15.1318 16.0058 15.2626 15.9796 15.3844 15.9289C15.5063 15.8781 15.6169 15.8037 15.7098 15.71C15.8036 15.617 15.878 15.5064 15.9287 15.3846C15.9795 15.2627 16.0056 15.132 16.0056 15C16.0056 14.868 15.9795 14.7373 15.9287 14.6154C15.878 14.4936 15.8036 14.383 15.7098 14.29L13.4098 12L15.7098 9.70999C15.8036 9.61702 15.878 9.50642 15.9287 9.38456C15.9795 9.26271 16.0056 9.132 16.0056 8.99999C16.0056 8.86798 15.9795 8.73727 15.9287 8.61541C15.878 8.49355 15.8036 8.38295 15.7098 8.28999ZM19.0698 4.92999C18.1474 3.97489 17.0439 3.21306 15.8239 2.68897C14.6038 2.16488 13.2916 1.88902 11.9638 1.87748C10.6361 1.86595 9.31926 2.11896 8.09029 2.62177C6.86133 3.12458 5.74481 3.86711 4.80589 4.80604C3.86696 5.74497 3.12443 6.86148 2.62162 8.09045C2.11881 9.31941 1.86579 10.6362 1.87733 11.964C1.88887 13.2918 2.16473 14.604 2.68882 15.824C3.21291 17.0441 3.97473 18.1475 4.92984 19.07C5.8523 20.0251 6.95575 20.7869 8.17579 21.311C9.39583 21.8351 10.708 22.111 12.0358 22.1225C13.3636 22.134 14.6804 21.881 15.9094 21.3782C17.1383 20.8754 18.2549 20.1329 19.1938 19.1939C20.1327 18.255 20.8752 17.1385 21.3781 15.9095C21.8809 14.6806 22.1339 13.3638 22.1223 12.036C22.1108 10.7082 21.8349 9.39598 21.3109 8.17594C20.7868 6.9559 20.0249 5.85246 19.0698 4.92999ZM17.6598 17.66C16.3519 18.9694 14.6304 19.7848 12.7886 19.9673C10.9469 20.1498 9.09884 19.688 7.55936 18.6608C6.01987 17.6335 4.88419 16.1042 4.34581 14.3335C3.80742 12.5627 3.89964 10.6601 4.60675 8.94977C5.31386 7.23941 6.59211 5.82714 8.22373 4.95355C9.85534 4.07996 11.7394 3.79912 13.5548 4.15886C15.3703 4.5186 17.0049 5.49668 18.1801 6.92645C19.3553 8.35622 19.9984 10.1492 19.9998 12C20.0034 13.0513 19.7984 14.0928 19.3968 15.0644C18.9951 16.0359 18.4047 16.9181 17.6598 17.66Z"
        fill="white"
      />
    </svg>

  )
}

export const CloseSvg = ({ className = '' }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </svg>
);

export const DownloadSvg = ({ className = '' }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </svg>
);

export const ResetSvg = ({ className = '' }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />
  </svg>
);

export const UndoSvg = ({ className = '' }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
  </svg>
);

export const RedoSvg = ({ className = '' }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z" />
  </svg>
);

export const EditSvg = ({ className = '' }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
  </svg>
);

export { SearchSvg, LikeSvg, UserSvg, CartSvg, HomeSvg, HalfStar, JobSvg, FootballSvg, CheckedSvg, LikePurpleSvg, UploadSvg, EmptyStar, CartwhiteSvg, FullStar, CrossSvg, RadioSvg, CanselSvg, PasswordSvg }